import { UsersLambdaFetch, awaitJSON } from './fetch-utils';

export const ErrorReportStatus = {
  SENT: 'sent',
  DUPLICATE: 'duplicate',
  FAILED: 'failed'
} as const;
export type ErrorReportStatusType = (typeof ErrorReportStatus)[keyof typeof ErrorReportStatus];

interface ErrorReportInput {
  referenceId: string;
  errorMessage: string;
  note?: string;
}

// Posts a user-initiated error report (bpm-lambdas users/errorReport, which relays it to Slack).
// The page URL drops the query string. A failed Slack post
// comes back as HTTP 202 with status 'failed', so callers branch on the status, not on a throw.
export const sendErrorReport = async ({
  referenceId,
  errorMessage,
  note
}: ErrorReportInput): Promise<ErrorReportStatusType> => {
  const { origin, pathname } = window.location;
  const res = await UsersLambdaFetch('/errorReport', {
    method: 'POST',
    body: { referenceId, pageUrl: `${origin}${pathname}`, errorMessage, note: note || undefined }
  });
  const { status } = await awaitJSON<{ status: ErrorReportStatusType }>(res);
  // An unexpected or missing status is a failure, not a success.
  return Object.values(ErrorReportStatus).includes(status) ? status : ErrorReportStatus.FAILED;
};
